import Vue from 'vue'
import Router from 'vue-router'

import Base from '@/view/base/index'
import Help from '@/view/base/help'
import Finish from '@/view/base/finish'
import ProductList from '@/view/product/productList'
import GoodsEvaluate from '@/view/product/evaluate'
import PingJiaList from '@/view/product/pingjiaList'
import PayResult from '@/view/product/payResult'
import Detail from '@/view/product/detail'
import Sort from '@/view/product/sort'
import User from '@/view/user/user'
import AddressList from '@/view/address/list'
import AddressDetail from '@/view/address/detail'
import CouponList from '@/view/coupon/list'
import CouponCenter from '@/view/coupon/center'
import Order from '@/view/order/index'
import OrderDetail from '@/view/order/detail'
import OrderAddress from '@/view/order/orderAddress'
import OrderFapiao from '@/view/order/orderFapiao'
import OrderFapiaoList from '@/view/order/orderFapiaoList'
import OrderApplyFapiao from '@/view/order/orderApplyFapiao'
import OrderPingJia from '@/view/order/pingjia'
import ShouHou from '@/view/order/shouhouList'
import WuLiuDetail from '@/view/order/wuliuDetail'
import customize from '@/view/customize/index'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/',
    name: 'base',
    component: Base,
  },
  {
    path: '/help',
    name: 'help',
    component: Help,
  },
  {
    path: '/finish',
    name: 'finish',
    component: Finish,
  },
  {
    path: '/productlsit',
    name: 'ProductList',
    component: ProductList,
  },
  {
    path: '/goodsEvaluate',
    name: 'goodsEvaluate',
    component: GoodsEvaluate,
  },
  {
    path: '/pingjiaList',
    name: 'PingJiaList',
    component: PingJiaList,
  },
  {
    path: '/productDetail',
    name: 'ProductDetail',
    component: Detail,
  },
  {
    path: '/payResult',
    name: 'PayResult',
    component: PayResult,
  },
  {
    path: '/user',
    name: 'User',
    component: User,
  },
  {
    path: '/addressList',
    name: 'AddressList',
    component: AddressList,
  },
  {
    path: '/addressDetail',
    name: 'AddressDetail',
    component: AddressDetail,
  },
  {
    path: '/sort',
    name: 'Sort',
    component: Sort,
  },
  {
    path: '/couponList',
    name: 'CouponList',
    component: CouponList,
  },
  {
    path: '/couponCenter',
    name: 'CouponCenter',
    component: CouponCenter,
  },
  {
    path: '/orderList',
    name: 'Order',
    component: Order,
  },
  {
    path: '/orderDetail',
    name: 'OrderDetail',
    component: OrderDetail,
  },
  {
    path: '/orderAddress',
    name: 'OrderAddress',
    component: OrderAddress,
  },
  {
    path: '/orderFapiao',
    name: 'OrderFapiao',
    component: OrderFapiao,
  },
  {
    path: '/orderFapiaoList',
    name: 'OrderFapiaoList',
    component: OrderFapiaoList,
  },
  {
    path: '/orderApplyFapiao',
    name: 'OrderApplyFapiao',
    component: OrderApplyFapiao,
  },
  {
    path: '/pingjia',
    name: 'OrderPingJia',
    component: OrderPingJia,
  },
  {
    path: '/shouhouList',
    name: 'ShouHou',
    component: ShouHou,
  },
  {
    path: '/wuliuDetail',
    name: 'WuLiuDetail',
    component: WuLiuDetail,
  },
  {
    path: '/customize',
    name: 'customize',
    component: customize,
  },
]

export default new Router({
  // mode: 'history',
  routes: constantRouterMap,
})



// WEBPACK FOOTER //
// ./src/router/index.js